// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-components/build/generate-icons

import { question16X16 } from '@ni/nimble-tokens/dist/icons/js';
import { IconSvg, registerIconSvg } from '../../icon-svg';

declare global {
    interface HTMLElementTagNameMap {
        'nimble-icon-question': IconQuestion;
    }
}

/**
 * The icon component for the 'question' icon
 */
export class IconQuestion extends IconSvg {
    public constructor() {
        super(question16X16);
    }
}

registerIconSvg('icon-question', IconQuestion);
export const iconQuestionTag = 'nimble-icon-question';
